import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappNumber = "917498963176";
  const message = encodeURIComponent("Hi, I'd like to know more about Nova Homes.");
  
  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-50 bg-[#111111] hover:bg-[#222222] text-white p-3.5 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 group"
    >
      <MessageCircle size={22} />
      <span className="hidden group-hover:inline-block text-sm font-medium whitespace-nowrap pr-1 tracking-wide">
        WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
